var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countdown !== 0)?_c('div',{staticClass:"mb-container"},[_c('div',{class:{
    'mb-countdown': true,
    'bg3': _vm.hoursText.length > 2
  }},[_c('span',{staticClass:"mb-hoursText"},[_vm._v(_vm._s(_vm.hoursText))]),_c('span',{staticClass:"mb-minsText"},[_vm._v(_vm._s(_vm.minsText))]),_c('span',{staticClass:"mb-ssText"},[_vm._v(_vm._s(_vm.ssText))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }